module.exports = __webpack_public_path__ + "img/ic_emoji_angry.b7e34575.png";